import routes from 'src/routes';

import { useTranslations } from 'next-intl';

import CustomLink from 'src/components/CustomLink';

interface HelpProps {
  caseWorkerNumber?: string;
  caseWorkerName?: string;
  organizationName?: string;
}

const SupportSection = (props: HelpProps) => {
  const t = useTranslations('support');

  return (
    <section>
      <h2 className="ma__comp-heading">{t('need_support')}</h2>
      <p>
        {t.rich('support_body', {
          link: () => (
            <CustomLink href={`tel:${props.caseWorkerNumber ?? routes.external.phones.mass_211_contact_number}`}>
              {props.caseWorkerNumber ?? routes.external.phones.mass_211_contact_number}
            </CustomLink>
          ),
          organizationName: props.organizationName ?? t('organization_name'),
        })}
      </p>
    </section>
  );
};

export default SupportSection;
